<dx-popup
    #workorderProposalHistoryPopup
    minWidth="150px"
    minHeight="150px"
    width="40%"
    height="35%"
    title="Work Order Proposal History"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        width="100%"
                        height="100%"
                        allowColumnResizing="true"
                        [dataSource]="historySource"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [hoverStateEnabled]="true"
                        [columnAutoWidth]="true"
                        [showBorders]="true"
                    >
                        <dxi-column
                            dataField="fileName"
                            dataType="string"
                            caption="File Name"
                            cellTemplate="fileTemplate"
                        ></dxi-column>
                        <dxi-column
                            dataField="generatedBy"
                            dataType="object"
                            caption="Generated By"
                            cellTemplate="userTemplate"
                        ></dxi-column>
                        <dxi-column
                            dataField="generatedOn"
                            dataType="date"
                            caption="Generated On"
                            [format]="dateFormat"
                        ></dxi-column>

                        <div *dxTemplate="let row of 'userTemplate'">
                            <app-user-bio-link [user]="row.value" [communityId]="communityId"></app-user-bio-link>
                        </div>

                        <div *dxTemplate="let row of 'fileTemplate'">
                            <app-hyperlink-creator
                                mode="hyperlinkOnly"
                                [displayText]="row.value"
                                (onLinkClick)="onDownloadFile(row.data)"
                            ></app-hyperlink-creator>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="toolbar-container">
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onPopupClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
